import React from 'react';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';
import { UploadMultiFile } from 'src/components/upload';

function AdjuntarArchivosModal(props) {
  const { open, close } = props;
  const { fetch: sendFiles, loading } = useFetch();

  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);

  const adjuntarArchivos = React.useCallback(
    async (files) => {
      const form = new FormData();

      for (const file of files) {
        form.append('files', file);
      }

      await sendFiles(`/tickets/${props?.data?.codigo}/archivos-adjuntos`, {
        method: 'POST',
        data: form,
      });
    },
    [sendFiles, props.data.codigo],
  );

  return (
    <Modal
      title={`Adjuntar Archivos: ${props?.data.codigo}`}
      content={
        <UploadMultiFile
          onUpload={adjuntarArchivos}
          isUploading={loading}
          afterUpload={onCloseModal}
        />
      }
      open={open}
      close={onCloseModal}
      onConfirm={adjuntarArchivos}
      loading={loading}
      showConfirmButton={false}
      cancelButtonText="Cerrar"
      cancelButtonPosition="top"
    />
  );
}

export default AdjuntarArchivosModal;
